import React from 'react'

const AdminManageUsers = () => {
  return (
    <div>Admin Manage Users Page</div>
  )
}

export default AdminManageUsers